import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(() => ({
  generalInfo: {
    margin: "0 auto",
    padding: "0 0 40px 0",
    "& .section": {
      paddingBottom: "60px",
      margin: "0 auto"
    }
  },
  userOptions: {
    display: "flex",
    flexDirection: "row"
  },
  spaceBottom: {
    paddingBottom: "20px"
  }
}))

export default styles
